import { VoiceConversationModel } from "../schema";

export class VoiceConversationContainer {
    voice_conversation: VoiceConversationModel
}